import React, { useEffect, useState } from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import call from "../../Api/call";
import { useTranslation } from "react-i18next";

interface PdfPreviewProps {
  documentId?: number;
  url?: string;
}

const PdfPreview: React.FC<PdfPreviewProps> = ({ documentId, url: source }) => {
  const [blobUrl, setBlobUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const { t } = useTranslation("documentUpload");

  const fetchPath =
    source ?? `/v1/document/${documentId}/?disposition=inline`;

  useEffect(() => {
    let url: string | null = null;
    let cancelled = false;

    call
      .get(fetchPath, {
        responseType: "blob",
      })
      .then((response) => {
        if (!cancelled) {
          const blob = new Blob([response.data], { type: "application/pdf" });
          url = URL.createObjectURL(blob);
          setBlobUrl(url);
          setLoading(false);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setError(true);
          setLoading(false);
        }
      });

    return () => {
      cancelled = true;
      if (url) URL.revokeObjectURL(url);
    };
  }, [fetchPath]);

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "70vh",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (error || !blobUrl) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "70vh",
        }}
      >
        <Typography variant="body1" color="error">
          {t("documentUpload.pdfPreview.errorLoadingPreview")}
        </Typography>
      </Box>
    );
  }

  return (
    <iframe
      title={t("documentUpload.pdfPreview.title")}
      src={blobUrl}
      style={{ width: "100%", height: "80vh", border: 0 }}
    />
  );
};

export default PdfPreview;
